<template>
  <section
    class="Fiche__title text-ttgros"
    style="font-style: italic; position: relative; top: 4px;"
    v-if="pm.axe !== 1"
  >
    <span>{{ secondAxe ? secondAxe.name : "" }}</span>
  </section>
</template>
<script>
export default {
  name: "titre-fiche-a3-droite",
  props: {
    pm: {},
    secondAxe: {}
  }
};
</script>
